import { render, staticRenderFns } from "./AddEditRatingDirection.vue?vue&type=template&id=adc975c6"
import script from "./AddEditRatingDirection.vue?vue&type=script&lang=js"
export * from "./AddEditRatingDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports